import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const WelcomeModal = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const hasSeenModal = localStorage.getItem("hasSeenWelcomeModal") === "true";

        if (!hasSeenModal) {
            setShow(true);
            localStorage.setItem("hasSeenWelcomeModal", "true");
        }
    }, []);

    return (
        <Modal show={show} onHide={() => setShow(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Bem-vindo ao SGU</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Este sistema possibilita a gestão de um ou mais equipamentos conectados,
                garantindo controle total para prevenir erros operacionais e uso indevido.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => setShow(false)}>
                    Entendi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WelcomeModal;
